import React, { useState } from 'react';
import { api } from '../utils/api';

export default function Login({ onLogin }) {
  const [tab, setTab] = useState('login');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ email: '', password: '', name: '', dealerName: '', dealer_type: 'independent', phone: '', city: '', state: '' });

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleLogin = async () => {
    setLoading(true); setError('');
    const d = await api.login(form.email, form.password);
    setLoading(false);
    if (d.error) { setError(d.error); return; }
    onLogin(d.token, d.user);
  };

  const handleRegister = async () => {
    setLoading(true); setError('');
    const d = await api.register(form);
    setLoading(false);
    if (d.error) { setError(d.error); return; }
    setTab('login');
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: 'linear-gradient(135deg, #0f0f0f 0%, #1a0000 100%)' }}>
      <div style={{ background: '#1a1a1a', border: '1px solid #cc0000', borderRadius: 12, padding: 40, width: '100%', maxWidth: 420 }}>
        <h1 style={{ color: '#cc0000', fontSize: 28, marginBottom: 6, textAlign: 'center' }}>RED ZONE</h1>
        <p style={{ color: '#888', textAlign: 'center', marginBottom: 28 }}>Dealer Management System</p>

        <div style={{ display: 'flex', marginBottom: 24, borderRadius: 8, overflow: 'hidden', border: '1px solid #333' }}>
          {['login', 'register'].map(t => (
            <button key={t} onClick={() => setTab(t)} style={{ flex: 1, padding: 10, background: tab === t ? '#cc0000' : '#111', border: 'none', color: tab === t ? '#fff' : '#888', cursor: 'pointer', fontSize: 14 }}>
              {t === 'login' ? 'Login' : 'Register Dealership'}
            </button>
          ))}
        </div>

        {tab === 'login' ? (
          <>
            <div className="form-group"><label>Email</label><input type="email" value={form.email} onChange={e => set('email', e.target.value)} placeholder="you@dealership.com" onKeyDown={e => e.key === 'Enter' && handleLogin()} /></div>
            <div className="form-group"><label>Password</label><input type="password" value={form.password} onChange={e => set('password', e.target.value)} placeholder="" onKeyDown={e => e.key === 'Enter' && handleLogin()} /></div>
            <button className="btn-red" style={{ width: '100%', padding: 12, fontSize: 15 }} onClick={handleLogin} disabled={loading}>{loading ? 'Signing in...' : 'Sign In'}</button>
          </>
        ) : (
          <>
            <div className="form-group"><label>Your Name</label><input type="text" value={form.name} onChange={e => set('name', e.target.value)} placeholder="John Smith" /></div>
            <div className="form-group"><label>Dealership Name</label><input type="text" value={form.dealerName} onChange={e => set('dealerName', e.target.value)} placeholder="Auto Finance Advantage" /></div>
            <div className="form-group"><label>Dealership Type</label>
              <select value={form.dealer_type} onChange={e => set('dealer_type', e.target.value)}>
                <option value="independent">Independent Used Car</option>
                <option value="bhph">Buy Here Pay Here (BHPH)</option>
                <option value="franchise">Franchise Dealer</option>
                <option value="wholesale">Wholesale / Auction</option>
                <option value="powersports">RV / Powersports</option>
                <option value="commercial">Commercial / Fleet</option>
              </select>
            </div>
            <div className="form-group"><label>Email</label><input type="email" value={form.email} onChange={e => set('email', e.target.value)} placeholder="you@dealership.com" /></div>
            <div className="form-group"><label>Password</label><input type="password" value={form.password} onChange={e => set('password', e.target.value)} /></div>
            <div className="form-grid">
              <div className="form-group"><label>City</label><input type="text" value={form.city} onChange={e => set('city', e.target.value)} placeholder="Summerville" /></div>
              <div className="form-group"><label>State</label><input type="text" value={form.state} onChange={e => set('state', e.target.value)} placeholder="SC" /></div>
            </div>
            <button className="btn-red" style={{ width: '100%', padding: 12, fontSize: 15 }} onClick={handleRegister} disabled={loading}>{loading ? 'Creating...' : 'Create Account'}</button>
          </>
        )}
        {error && <div className="error-msg" style={{ textAlign: 'center', marginTop: 12 }}>{error}</div>}
      </div>
    </div>
  );
}
